const PT = {
  acceptRequest: "Aceitar o pedido",
  accessDetail: "Detalhe de acesso",
  accessoryUnavailable: "Acessório(s) não disponível(is)",
  actions: "Ações",
  activity: "Atividade",
  add: "Adicionar",
  addAgency: "Adicionar agência",
  addAgencyInfoBullet1: "Solicitar orçamentos e fazer encomendas diretamente.",
  addAgencyInfoBullet2: "Beneficiar dos preços dos contratos-quadro existentes.",
  addAgencyInfoBullet3: "Aceder aos recursos que lhes atribuir.",
  addAgencyInfoTitle: "Ao adicionar esta agência, os seus clientes poderão:",
  addDocuments: "Adicionar documentos",
  addEvent: "Adicionar evento",
  addFile: "Adicionar ficheiro",
  addInformation: "Adicionar informação",
  additionalInformation: "Informação adicional",
  addMessageToCustomer: "Mensagem para o cliente",
  addNewDocument: "Adicionar novo documento",
  addParticipant: "Adicionar participante",
  addResource: "Adicionar um recurso",
  address: "Endereço",
  addUser: "Adicionar um utilizador",
  agencies: "Agências",
  agency: "Agência",
  agencyArchived: "Agência arquivada",
  agencyCreated: "Agência criada",
  agencyIsRequired: "Agência obrigatória",
  agencyName: "Nome da agência",
  agencyUpdated: "Agência atualizada",
  allFilesUpToDate: "Todos os ficheiros estão atualizados",
  allMyOrders: "Todas as minhas encomendas",
  allResources: "Todos os recursos",
  alreadyCustomer: "Já é cliente?",
  analytics: "Análise",
  anErrorOccurred: "Ocorreu um erro",
  apiStatus: "Estado da API",
  applicant: "Requerente",
  applicationVersion: "Versão da aplicação",
  archive: "Arquivar",
  archive_one: "{{count}} Arquivo",
  archive_other: "{{count}} Arquivos",
  archiveAgency: "Arquivar agência",
  archiveAgencyConfirmation:
    "Tem a certeza de que pretende arquivar a agência {{name}}? Todos os contratos relacionados serão arquivados e os pedidos de reserva pendentes serão cancelados.",
  archived: "Arquivada",
  areYouAConstructionCompany: "É uma empresa de construção?",
  areYouSureYouWantDetachResource: "Tem certeza de que deseja desvincular o recurso deste pedido?",
  areYouSureYouWantDetachUser:
    "Tem certeza de que deseja desvincular este utilizador da agência? Este utilizador será notificado por e-mail.",
  areYouSureYouWantToDelete: "Tem a certeza de que deseja eliminar?",
  areYouSureYouWantToDeleteWithItem: "Tem a certeza de que deseja eliminar {{item}}?",
  article: "Artigo",
  articleAccess: "Acesso ao artigo",
  articleCategory: "Categoria",
  articleEquipmentUpdated: "Equipamento do artigo atualizado",
  articleInformation: {
    message: "Escolha uma máquina da sua frota interna ou um operador",
    warningDescription: "Informação do equipamento em falta. Forneça os documentos e informações necessários antes do início do aluguel.",
    warningTitle: "Informação do equipamento em falta",
  },
  articleNameIsRequired: "O nome do artigo é obrigatório",
  articles: "Artigos",
  assignment: "Atribuição",
  associatedMachine: "Máquina associada",
  attachAResource: "Selecionar um recurso",
  attachResource: "Associar um recurso",
  availability: "Disponibilidade",
  available: "Disponível",
  backToLogin: "Voltar ao login",
  beginning: "Início",
  between: "entre",
  billing: "Faturação",
  billingDetailsAssociatedWithThisOrder: "Detalhes da faturação associados a esta encomenda",
  billings: "Faturamentos",
  booking: {
    addAnItem: "Adicionar um item",
    automaticExtension: "Extensão automática",
    bankingHolidays: "Feriados",
    date: "Data",
    day: "Dias",
    days: "Dias",
    fromDate: "Data de início",
    saturday: "Sábado",
    sunday: "Domingo",
    toDate: "Data de fim",
    useOn: "Usar em:",
  },
  bookingDate: "{{fromDate}} a {{toDate}}",
  bookingEnd: "Fim da reserva",
  bookingStart: "Início da reserva",
  bookingStartTomorrow: "A reserva começa amanhã",
  bookingStartTomorrowMessage:
    "Certifique-se de que tudo está pronto para a entrega, respeitando as restrições do cliente e incluindo acessórios solicitados, se aplicável.",
  bookings: "Reservas",
  brand: "Marca",
  brandIsRequired: "A marca é obrigatória",
  breadcrumbs: {
    booking: {
      requests: "n°{{id}}",
    },
  },
  by: "por",
  byFile: "por ficheiro",
  cancel: "Cancelar",
  canceled: "Cancelado",
  category: "Categoria",
  categoryName: "Nome da categoria",
  ceCertificate: "Certificado CE",
  changePasswordAccount: "Alterar a senha da sua conta Tracktor",
  chat: "Conversar",
  clickToUpload: "Clique para carregar",
  client: "Cliente",
  clientRequest: "Pedido do cliente",
  clients: "Clientes",
  clientWillBeNotifiedByEmail: "O utilizador convidado será notificado por e-mail.",
  close: "Fechar",
  closed: "Fechado",
  closedAt: "Fechado em {{date}}",
  closedAtIncidentAlert: "Fechado em {{date}} por {{by}}",
  closeTheIncident: "Fechar o incidente",
  code: "Código",
  codeOrKeysLocation: "Código ou localização das chaves",
  commandPosts: "Postos de comando",
  company: "Empresa",
  completed: "Concluído",
  confirm: "Confirmar",
  confirmed: "Confirmado",
  contactAction: "Contactar",
  contacts: "Contactos",
  continue: "Continuar",
  couldNotFindBookingItem: "Não foi possível encontrar o item de reserva",
  countryCode: "Código do país",
  createAPasswordForYourAccount: "Crie uma senha para a sua conta",
  createNewResource: "Criar um novo recurso",
  createNewUser: "Criar novo utilizador",
  createYourFirstConversation: "Crie sua primeira conversa",
  currentApiVersion: "Versão atual da API",
  currentApiVersionUsed: "Versão da API utilizada",
  darkMode: "Modo escuro",
  darkTheme: "Tema escuro",
  dashboard: "Painel",
  dataSheet: "Ficha técnica",
  date: {
    endDate: "Data de fim",
    startDate: "Data de início",
  },
  dates: "Datas",
  dayCount_one: "{{count}} Dia",
  dayCount_other: "{{count}} Dias",
  deals: "Negócios",
  dealsView: {
    detailed: "Detalhado",
    grouped: "Agrupado",
    kanban: "Kanban",
    list: "Lista",
    planning: "Planeamento",
  },
  delete: "Eliminar",
  deleteBookingFileMessage: "Tem a certeza de que deseja eliminar este ficheiro da reserva?",
  deleteConversation: "Eliminar conversa",
  deleteFile: "Eliminar ficheiro",
  deleteFileConfirmation: "A eliminação do ficheiro é irreversível. Tem a certeza de que deseja continuar?",
  deleteResource: "Eliminar recurso",
  deleteResourceConfirmation:
    "A eliminação de um recurso é irreversível e eliminará todos os ficheiros associados. Tem a certeza de que deseja continuar?",
  delivery: "Entrega",
  deliveryAndReturn: "Entrega e Devolução",
  deliveryTimeConstraint: "Restrição de horário de entrega",
  designation: "Designação",
  detach: "Desanexar",
  detachResource: "Desanexar recurso",
  detachUser: "Desanexar utilizador",
  detachUserSuccessfully: "Utilizador desanexado com sucesso",
  document: "documento",
  documentAdded: "Documento adicionado",
  documentDeleted: "Documento eliminado",
  documentExp: "Doc. exp.",
  documentIssue_one: "{{count}} doc a fornecer",
  documentIssue_other: "{{count}} docs a fornecer",
  documentIssueTooltip_one: "{{count}} documento em falta ou expirado",
  documentIssueTooltip_other: "{{count}} documentos em falta ou expirados",
  documentMissing_one: "{{count}} doc em falta",
  documentMissing_other: "{{count}} docs em falta",
  documentName: "Nome do documento",
  documents: "Documentos",
  documentsOk: "Docs OK",
  documentType: "Tipo de documento",
  documentUpdated: "Documento atualizado",
  edit: "Editar",
  editInfoDocument: "Editar informações do documento",
  editMyPassword: "Editar minha senha",
  editResource: "Editar recurso",
  editUser: "Editar utilizador",
  email: "Email",
  emailSent: "Email enviado",
  emailSentForgotPassword: "Um email foi enviado para redefinir a sua senha.",
  emptyBooking: "Não tem reservas futuras",
  emptyBookingMissing: "Não tem pedidos perdidos",
  emptyState: {
    noDealsFound: "Ainda não tem nenhuma encomenda",
    noDealsFoundDescription: "As suas novas encomendas serão apresentadas nesta tabela.",
    pageNotFoundDescription: "A página que procura não foi encontrada. Verifique o URL ou volte para a página anterior.",
    returnToOrders: "Voltar aos pedidos",
  },
  end: "Fim",
  enterTheCode: "Introduza o código",
  enterToSend: "↵ Enter para enviar · ⇧ Shift+↵ Enter para nova linha",
  enterYourCode: "Introduza o seu código",
  enterYourMessage: "Introduza a sua mensagem",
  entity: "Entidade",
  equipment: "Equipamento",
  equipmentInformation: {
    maximumPlates: "Carga máxima no patim (T)",
    sizePlates: "Tamanho das placas de distribuição (m²)",
    skid: "Pressão máxima sob a placa de distribuição (T/m²)",
  },
  equipmentNotOffered: "Equipamento não oferecido",
  error: {
    missingArticle: "Artigo em falta",
    missingDates: "Datas em falta",
    missingQuantity: "Quantidade em falta",
    missingUnitPrice: "Preço unitário em falta",
    noBookingFound: "Nenhuma reserva encontrada",
    noClientFoundForThisRequest: "Nenhum cliente encontrado para este pedido",
    pleaseFillFields: "Por favor, preencha todos os campos obrigatórios",
    pleaseSelectArticleBeforeAddingNewOne: "Por favor, selecione um artigo antes de adicionar um novo",
    positiveValueOnly: "Apenas valores positivos são permitidos",
    resourceMustBeSelected: "Deve selecionar um recurso",
    selectDates: "Por favor, selecione as datas de início e fim",
    shouldBeANumber: "Deve ser um número",
    someRequestDataAreMissing: "Faltam alguns dados do pedido",
    unknownError: "Erro desconhecido, tente novamente",
  },
  error404: "Erro 404",
  errorLoadingRequests: "Ocorreu um erro ao carregar os pedidos",
  escape: "Escape",
  eventStatus: {
    accepted: "Pedido de aluguel aceite",
    canceled: "Pedido de aluguel cancelado",
    refused: "Pedido de aluguel recusado",
    sent: "Pedido de aluguel recebido",
  },
  eventUpdated: "Evento atualizado",
  expirationDate: "Data de validade",
  expired: "Expirado",
  file: "o documento",
  fileAddedSuccessfully: "Ficheiro adicionado com sucesso",
  fileArchivedSuccessfully: "Ficheiro arquivado com sucesso",
  fileDeletedSuccessfully: "Ficheiro eliminado com sucesso",
  fileHasBeenUploaded: "O ficheiro foi carregado",
  fileName: "Nome do ficheiro",
  fileStatus: {
    expired: "Expirado",
    expires_soon: "Expira em breve",
    up_to_date: "Atualizado",
  },
  files: "Ficheiros",
  filesNotUpToDate: "Alguns ficheiros não estão atualizados",
  fileType: "Tipo de ficheiro",
  fileUnarchivedSuccessfully: "Ficheiro desarquivado com sucesso",
  finish: "Concluir",
  finishDayCount: "Este termo termina em {{count}} dias",
  finishToday: "Termina hoje",
  finishTomorrow: "Termina amanhã",
  firstName: "Nome próprio",
  flatRate: "Taxa fixa",
  fleetNumber: "Número de frota",
  forgottenPassword: "Senha esquecida",
  forgottenPasswordSubtitle: "Introduza o seu email. Enviaremos um link para redefinir a sua senha",
  form: {
    constraint: {
      password: "A senha deve conter pelo menos 8 caracteres e uma letra maiúscula",
    },
    validation: {
      required: "Este campo é obrigatório",
    },
  },
  generalTerms: "Termos gerais",
  getSupport: "Obter apoio",
  giveFeedback: "Dar feedback",
  globalSearchPlaceholder: "Introduza um ID de negócio ou nome de artigo",
  happyToSeeYouAgain: "Feliz por vê-lo novamente!",
  help: "Ajuda",
  helperText: {
    onlyImageFilesAreAllowed: "Apenas ficheiros .png, .jpeg, .pdf são permitidos",
  },
  history: "Histórico",
  home: "Início",
  icon: "Ícone",
  identity: "Identidade",
  identityCard: "Cartão de identidade",
  import: "Importar",
  importFile: "Importar ficheiro",
  incidentAddedSuccessfully: "Incidente adicionado com sucesso",
  incidentClosed: "Incidente fechado",
  incidentOpened: "Incidente aberto",
  indicateCodeOrKeysLocation: "Indique o código ou a localização das chaves",
  information: "Informação",
  informations: "Informações",
  inProgress: "Em curso",
  instructionManual: "Manual de instruções",
  insurance: "Seguro",
  internalCode: "Código interno",
  internalCodeIsRequired: "O código interno é obrigatório",
  invoice: "Fatura",
  irreversibleAction: "Esta ação é irreversível",
  key: "Chave",
  keyLocation: "Localização da chave",
  keys: "Chaves",
  language: "Idioma",
  lastName: "Apelido",
  linkDocuments: "Ligar documentos",
  linkDocumentsToBooking: "Documentos visíveis para o cliente",
  list: "Lista",
  logIn: "Inicie sessão",
  login: "Iniciar sessão",
  logout: "Terminar sessão",
  machine: "Máquina",
  machineRegistration: "Registro da máquina",
  mail: "Email",
  maintenanceLog: "Registro de manutenção",
  makeAnOffer: "Fazer uma oferta",
  material: "Material",
  materialDropOffPoint: "Ponto de entrega do material",
  messagePlaceholder: "Carga máxima no patim (T), dimensões das placas de distribuição (m²)…",
  messages: "Mensagens",
  messageToCustomer: "Mensagem para o cliente",
  missed: "Perdido",
  missingRole: "Função em falta",
  modifyMyOffer: "Modificar minha oferta",
  modifyOffer: "Modificar oferta",
  myProfile: "Meu perfil",
  name: "Nome",
  newConversation: "Nova conversa",
  newDate: "Nova data",
  newDateProposal: "Disponível a partir de outra data próxima",
  newDocument: "Novo documento",
  newMessage: "Nova mensagem",
  newMessageCount_one: "{{count}} nova mensagem",
  newMessageCount_other: "{{count}} novas mensagens",
  newPassword: "Nova senha",
  newPasswordConfirm: "Confirmar nova senha",
  newResourceCreated: "O seu novo recurso foi criado!",
  newResourceCreatedDetails: "Carregue documentos e as suas datas de validade.",
  next: "Próximo",
  nextAssignment: "Próxima atribuição",
  no: "Não",
  noAgenciesFound: "Nenhuma agência encontrada",
  noAvailability: "Sem disponibilidade e downgrade impossível",
  noDocumentsFound: "Nenhum documento encontrado",
  noEvents: "Nenhum evento",
  noFilesAttached: "Nenhum ficheiro anexado",
  noNameFound: "Nenhum nome encontrado",
  noOrderFound: "Nenhuma encomenda associada a este artigo foi encontrada",
  notAvailable: "Não disponível",
  notes: "Notas",
  notFound: "A página que procura não foi encontrada.",
  notFoundRedirection: "Verifique o URL ou volte à página anterior.",
  noUsersFound: "Nenhum utilizador encontrado",
  num: "N°",
  numberOfDays: "Número de dias",
  numberParc: "N° de frota",
  numberParcShort: "N° frota",
  offerSendTo: "A sua oferta foi enviada para {{name}}",
  offerSendToDetails: "Será notificado assim que o seu cliente aprovar a sua oferta.",
  onboarding: {
    featureRequests: {
      step1Description:
        "Os clientes veem imediatamente no Tracktor os fornecedores mais próximos da sua obra, classificados por distância e preços de contrato-quadro.",
      step1Title: "Aumente sua receita",
      step2Description:
        "Preencha o seu orçamento e envie-o. Ao responder rapidamente com um preço competitivo, você aumenta suas chances de ser escolhido pelo cliente!",
      step2Title: "Responda em apenas alguns cliques",
    },
  },
  open: "Aberto",
  openFullPage: "Abrir em página inteira",
  openFullScreen: "Abrir em ecrã completo",
  operator: "Operador",
  operatorDocExp: "Oper. exp.",
  operatorDocKo: "Oper. KO",
  operatorDocMissing_one: "{{count}} oper. ausente",
  operatorDocMissing_other: "{{count}} oper. ausentes",
  operatorDocument: "Documento do operador",
  order: "Encomenda",
  orderHistory: "Histórico de encomendas",
  orderSummary: "Resumo da encomenda",
  orders: "Encomendas",
  other: "Outro",
  oups: "Oups!",
  overview: "Visão geral",
  pageNotFound: "Página não encontrada",
  participants: "Participantes",
  password: "Senha",
  passwordSetSuccessfully: "A sua senha foi atualizada",
  passwordsNotMatching: "As senhas não coincidem",
  passwordUpdated: "A sua senha foi atualizada",
  payments: "Pagamentos",
  periodicGeneralInspection: "Inspeção geral periódica (PGI)",
  phone: "Telefone",
  phoneNumber: "Número de telefone",
  planning: "Planeamento",
  pleaseSetAPassword: "Por favor, defina uma senha",
  price: "Preço",
  priceExVAT: "Sem IVA",
  profile: "Meu perfil",
  profileUpdated: "O seu perfil foi atualizado",
  purchaseOrder: "Ordem de compra",
  purchaseOrderNumber: "Número da ordem de compra",
  quantity: "Quantidade",
  quote: "Orçamento",
  reason: "Motivo",
  received: "Recebido",
  refuse: "Recusar",
  refused: "Recusado",
  refusedBookingRequestMessage: "Ao confirmar a recusa deste pedido de reserva, não poderá aceitá-lo posteriormente.",
  refusedTheBooking: "Encomenda recusada",
  refuseRequest: "Recusar o pedido",
  releaseNotRequested: "O cliente ainda não solicitou a libertação",
  releaseRequestedForDate: "Libertação solicitada para {{date}}",
  reload: "Recarregar",
  rentalRequests: "Pedidos",
  reopenTheIncident: "Reabrir o incidente",
  replace: "Substituir",
  request: "Pedido",
  requestMissedAlert: {
    button: "Voltar aos meus pedidos",
    description1: "O cliente enviou este pedido a vários fornecedores e aceitou uma das ofertas.",
    description2:
      "No Tracktor, os fornecedores respondem em média em menos de uma hora: seja ágil para maximizar suas chances em futuras oportunidades.",
    redirection: "👉 Saiba mais sobre a pesquisa de fornecedores no Tracktor",
    title: "Pedidos perdidos",
  },
  requestOfferAlertInfoDescription:
    "Responder a cada solicitação (mesmo recusando) aumenta em 65% as chances de ser contatado novamente por este cliente.",
  requestOfferAlertInfoTitle: "Não perca nenhuma oportunidade",
  requestStatus: {
    expired: "Expirado",
    proposed: "Proposto",
    refused: "Recusado",
    toTreat: "A tratar",
  },
  requests: "Pedidos",
  requestWithID: "Pedidos n°{{id}}",
  required: "Obrigatório",
  reservation: "Reserva",
  reservationRequestAccepted: "Pedido de reserva aceito, a encomenda foi criada",
  reservationRequestInfo:
    "Ao aceitar, este pedido será automaticamente transformado numa encomenda com as condições indicadas acima. Aparecerá nas suas Encomendas e o cliente será informado.",
  resetInitialRequest: "Repor pedido inicial",
  resetPassword: "Redefinir senha",
  resource: "Recurso",
  resourceAddedSuccessfully: "Recurso adicionado com sucesso",
  resourceCreated: "Recursos criados",
  resourceDetachedSuccessfully: "Recurso desvinculado com sucesso",
  resourceEmptyState: {
    button: "Adicione o seu primeiro recurso",
    dialogContentText: "Adicione vários recursos de uma só vez importando um ficheiro (CSV, XLS, XLSX, PDF...) ou adicione manualmente.",
    dialogPrimaryButton: "Adicionar manualmente",
    dialogSecondaryButton: "Importar um ficheiro",
    dialogSuccessContentText:
      "O processamento dos seus recursos está em curso. Em breve estarão disponíveis no seu espaço e será notificado por email.",
    dialogSuccessTitle: "Recursos transferidos",
    dialogTitle: "Escolha o seu método",
    listSubtitle1: "Adicione um novo recurso ao seu espaço",
    listSubtitle2: "E especifique as datas de validade",
    listSubtitle3: "Todos os documentos serão enviados ao cliente",
    listTitle1: "Guardar um recurso",
    listTitle2: "Adicionar documentos",
    listTitle3: "Atribuí-lo a uma encomenda",
    title: "Adicione o seu primeiro recurso e simplifique a gestão das suas encomendas",
  },
  resourceName: "Nome do recurso",
  resourcePhoto: "Foto dos recursos",
  resourcePhotoHelperText: "PNG ou JPG (máx. 5 MB)",
  resources: "Recursos",
  resourceUpdated: "Recursos atualizados",
  resourceUpdatedSuccessfully: "Recurso atualizado com sucesso",
  respondToDemand: "Responder ao pedido",
  return: "Devolução",
  returnTo: "Voltar para",
  role: "Função",
  save: "Guardar",
  saveChanges: "Guardar alterações",
  search: "Pesquisar",
  searchContacts: "Pesquisar contactos",
  searchInApp: "Pesquisar na app",
  see: "Ver",
  seeDetail: "Ver detalhe",
  seeOffer: "Ver oferta",
  seeTheLines: "Ver as linhas",
  seeTheResource: "Ver o recurso",
  selectAnAgency: "Selecione uma agência",
  selectAnAgencyToAttachCategory: "Selecione uma agência para anexar esta categoria",
  selectAnotherResource: "Selecionar outro recurso",
  selectDocumentType: "Selecione o tipo de documento",
  selectExpirationDate: "Selecione a data de validade",
  selectResource: "Selecione o recurso",
  selectResourceWarning:
    "Ao selecionar este recurso, confirma que este atende às necessidades do cliente. O seu cliente será notificado por e-mail.",
  send: "Enviar",
  sendOffer: "Enviar oferta",
  sent: "Enviado",
  serialNumber: "Número de série",
  service: "Serviço",
  settings: "Parâmetros",
  siret: "SIRET / Número DNS",
  siretMustBe14Characters: "O SIRET deve ter exatamente 14 caracteres",
  sorenAnnouncement: {
    badge: "Em breve Soren",
    badgeSwitched: "Agora Soren",
    badgeSwitchedTooltip: "A Tracktor agora é Soren — saber mais",
    badgeTooltip: "A Tracktor passa a ser Soren — saber mais",
    gotIt: "Entendido",
    readArticle: "Ler o anúncio",
    story: {
      goToCard: "Cartão {{count}}",
      nextCard: "Cartão seguinte",
      previousCard: "Cartão anterior",
      switchTitle: "A Tracktor muda de nome até {{date}}.",
      switchTitlePast: "A Tracktor mudou de nome a {{date}}.",
      switchTitleToday: "A Tracktor muda de nome hoje.",
      thanksBody: "Pelas suas máquinas, as suas equipas e a sua confiança.",
      thanksBodyOrders_one: "{{number}} encomenda juntos. Pelas suas máquinas, as suas equipas e a sua confiança.",
      thanksBodyOrders_other: "{{number}} encomendas juntos. Pelas suas máquinas, as suas equipas e a sua confiança.",
      thanksTitle: "Obrigado, {{name}}.",
      thanksTitleAnonymous: "Obrigado.",
    },
    unchanged: {
      accessTitle: "Mesmos acessos",
      contactsTitle: "Mesmos interlocutores",
      ordersTitle: "As mesmas encomendas e clientes",
      title: "Nada muda além do nome e do logótipo.",
    },
  },
  startDayCount: "Começa em {{count}} dias",
  startToday: "Começa hoje",
  startTomorrow: "Começa amanhã",
  status: "Estado",
  supplier: "Fornecedor",
  supplierComment: "Comentário do fornecedor",
  TECHNICAL_SHEET: "Ficha técnica",
  theBookingRequestHasBeenAccepted: "A sua oferta foi enviada",
  theBookingRequestHasBeenRefused: "O pedido de reserva foi recusado",
  to: "Para",
  to_add: "A adicionar",
  toAdd: "A adicionar",
  toCome: "Por vir",
  toDo: "A fazer",
  today: "Hoje",
  tokenVerification: "Verificação do token",
  total: "Total",
  totalHT: "Total sem IVA",
  toUpdate: "A atualizar",
  type: "Tipo",
  typeToSearch: "Digite para pesquisar",
  unarchive: "Desarquivar",
  units: {
    DAYS_one: "{{count}} Dia",
    DAYS_other: "{{count}} Dias",
    HOURS_one: "{{count}} Hora",
    HOURS_other: "{{count}} Horas",
    KM: "{{count}} Km",
    null: "{{count}} ",
    unit: "Unidade",
    units: "Unidade",
    units_one: "{{count}} Unidade",
    units_other: "{{count}} Unidades",
  },
  up_to_date: "Atualizado",
  uploadFile: "Carregar ficheiro",
  upToDate: "Atualizado",
  userHasBeenAttachedToAgency: "O utilizador foi anexado à agência",
  users: "Utilizadores",
  usersActions: {
    archiveUser: "Arquivar utilizador",
    archiveUserSuccessfully: "Utilizador arquivado com sucesso",
    areYouSureYouWantToArchiveThisUser:
      "Tem certeza de que deseja arquivar este utilizador? Este utilizador não terá mais acesso ao espaço da agência e será notificado por e-mail.",
    unarchiveUser: "Desarquivar utilizador",
    unarchiveUserDescription: "Ao desarquivar este utilizador, ele recuperará o acesso ao espaço da agência e será notificado por e-mail.",
    unarchiveUserSuccessfully: "Utilizador desarquivado com sucesso",
    userUpdatedSuccessfully: "Utilizador atualizado com sucesso",
  },
  userUnarchivedSuccessfully: "Utilizador desarquivado com sucesso",
  validate: "Validar",
  worksiteAccessConstraints: "Restrições de acesso à obra",
  writeAMessage: "Escreva uma mensagem...",
  yes: "Sim",
  yesterday: "Ontem",
  yourAccount: "A sua conta",
  yourClientWillBeNotifiedByEmail: "O seu cliente será notificado por email.",
  yourOffer: "A sua oferta",
  yourOrdersAreWaitingForYouLogin: "As suas encomendas estão à sua espera, inicie sessão!",
  yourResourcesWillBeAddedToYourSpaceAfterProcessing: "Os seus recursos serão adicionados ao seu espaço após o processamento",
} as const;

export default PT;
